import instance from './axiosInstance';
import type { PolicySummaryResponse, PolicyDetailResponse } from 'pages/TrackingPolicy/utils/types';

export const getPolicySummary = async <T = PolicySummaryResponse>(params: {
  start_day: string;
  end_day: string;
}): Promise<T> => {
  const res = await instance.get('/policy-tracking/summary', { params });
  return res.data;
};

export const getPolicyDetail = async <T = PolicyDetailResponse>(params: {
  policy_id: number;
  start_day: string;
  end_day: string;
}): Promise<T> => {
  const res = await instance.get<T>('/policy-tracking/detail', { params });
  return res.data;
};
